export default "__VITE_ASSET__DDJbQJtd__"